import {forwardRef, LegacyRef, useRef} from 'react';
import {get} from 'lodash';

import styles from './styles.module.scss';
import ReactToPrint from 'react-to-print';
import PrintIcon from 'icons/PrintIcon';
import {Order} from 'types';
import useAuth from 'hooks/useAuth';

type Props = {
  order: any;
  driver: any;
};

const SignedDocument = forwardRef(
  ({order, driver}: Props, ref: LegacyRef<HTMLDivElement>) => {
    const orderRef = useRef(null);
    const {currentUser} = useAuth();

    if (order.status !== 'completed') {
      return null;
    }

    return (
      <div ref={ref}>
        <div
          style={{position: 'relative', zIndex: 1}}
          ref={orderRef}
          className={styles.root}
        >
          <div className={styles.center}>
            <p>{get(currentUser, 'company.name', '')}</p>
            <p>{get(currentUser, 'company.address', '')}</p>
            {get(currentUser, 'company.phone', '') && (
              <p>
                Phone: <span>{get(currentUser, 'company.phone', '')}</span>
              </p>
            )}
          </div>

          <p className={styles.clientHead}>Customer:</p>
          <p>
            {get(order, 'customer.user.first_name', '')}{' '}
            {get(order, 'customer.user.last_name', '')}
          </p>
          <p>
            {get(order, 'delivery_address.address_line_1')}{' '}
            {get(order, 'delivery_address.address_line_2')}
            {get(order, 'delivery_address.city')},{' '}
            {get(order, 'delivery_address.state')}{' '}
            {get(order, 'delivery_address.zipcode')}
          </p>
          <p>Phone# {get(order, 'customer.user.phone')}</p>
          <p>
            <b>Order# {get(order, 'id', 0)}</b>
          </p>
          <div className={styles.table}>
            <div className={styles.tableRow}>
              <div
                style={{
                  flex: 0,
                  width: 20,
                  minWidth: 20,
                }}
              >
                <p className={styles.boldtext}>No</p>
              </div>
              <div>
                <p className={styles.boldtext}>Item</p>
              </div>
              <div>
                <p className={styles.boldtext}>Order Date</p>
              </div>

              <div>
                <p className={styles.boldtext}>Amount due</p>
              </div>
              <div>
                <p className={styles.boldtext}>Payment Method</p>
              </div>

              <div>
                <p className={styles.boldtext}>Payment status</p>
              </div>
            </div>
            {get(order, 'orders', []).map((item: Order, index: number) => (
              <div key={index} className={styles.tableRow}>
                <div
                  style={{
                    flex: 0,
                    width: 20,
                    minWidth: 20,
                  }}
                >
                  <p>{index + 1}</p>
                </div>
                <div>
                  <p>{get(item, 'items[0].drug.name')}</p>
                </div>
                <div>
                  <p>{get(item, 'created_date', '')}</p>
                </div>

                <div>
                  <p>${get(item, 'items[0].amount_due', '')}</p>
                </div>
                <div>
                  <p>{get(item, 'payment_method') || '-'}</p>
                </div>

                <div>
                  <p>{!!get(item, 'paid_at', '') ? 'Paid' : 'Unpaid'}</p>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.row}>
            <div style={{minWidth: 200, marginLeft: 10}}>
              <p>
                Customer: {get(order, 'customer.user.first_name', '')}{' '}
                {get(order, 'customer.user.last_name', '')}
              </p>
              {get(order, 'total_cash_payment_amount', 0) === 0 ? (
                <p>Amount collected:</p>
              ) : (
                <p>
                  Cash on Delivery: $
                  {Number(get(order, 'total_cash_payment_amount', 0)).toFixed(
                    2
                  )}
                </p>
              )}

              <p>
                Date:{' '}
                {get(order, 'signed_date') ? get(order, 'signed_date') : ''}
              </p>
              <p>
                Time:{' '}
                {get(order, 'signed_time') ? get(order, 'signed_time') : ''}
              </p>
              <p>
                Staff: {get(driver, 'first_name', '')}{' '}
                {get(driver, 'last_name', '')}
              </p>
              <p>Receiver: {get(order, 'accepters_name', '')}</p>
            </div>
          </div>
          <div style={{justifyContent: 'flex-start'}} className={styles.row}>
            <p>Receiver's Signature:</p>
            <img
              src={get(order, 'signature.file', null)}
              className={styles.signatureImage}
              alt="Signature by customer"
            />
          </div>
          <div className={styles.print}>
            <ReactToPrint
              trigger={() => (
                <button className={styles.panel__deliveries_print_action}>
                  <PrintIcon size={16} />
                </button>
              )}
              content={() => orderRef.current}
            />
          </div>
          {!!get(order, 'delivery_image', null) && (
            <div
              style={{position: 'absolute', zIndex: -1, bottom: 110, right: 16}}
              className={styles.delivery_image}
            >
              <img
                alt="delivery_image"
                style={{
                  width: 150,
                }}
                src={get(order, 'delivery_image.medium', '')}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default SignedDocument;
